/** Mirror of backend/services/advisorDirectoryService SPECIALTY_PRESETS */
export const ADVISOR_DIRECTORY_SPECIALTIES = [
  'luxury',
  'groups',
  'honeymoons',
  'family',
  'adventure',
  'cruises',
  'corporate',
  'wellness',
  'safari',
  'cultural',
];

export const PARTNER_BUSINESS_TYPE_KEYS = {
  hotel: 'hotel',
  restaurant: 'restaurant',
  tour_operator: 'tourOperator',
  transport: 'transport',
  activity_provider: 'activityProvider',
  travel_agency: 'travelAgency',
  other: 'other',
};

export function websiteHref(website) {
  if (!website) return null;
  const raw = String(website).trim();
  if (!raw) return null;
  return /^https?:\/\//i.test(raw) ? raw : `https://${raw}`;
}

export function specialtyLabel(t, value) {
  const key = `advisorDirectory.specialties.${value}`;
  const translated = t(key);
  return translated === key ? value : translated;
}

export function formatBusinessTypeLabel(t, businessType, businessTypeOther) {
  const key = PARTNER_BUSINESS_TYPE_KEYS[businessType];
  if (key) {
    if (businessType === 'other' && businessTypeOther) return businessTypeOther;
    return t(`myInquiries.businessTypes.${key}`);
  }
  return businessTypeOther || businessType || '';
}
